import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "/advertiser/generate-product";
const options = {role: ROLE.ADVERTISER};


export const GetVertexAi = async (values) => {
  return await axiosInstance(options).post(`${path}/ai`, values);
};
